/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipForwardIcon24Regular = forwardRef('MediaUiASkipForwardIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.925 3.914C5.759 3.19 4.25 4.027 4.25 5.4v13.2c0 1.373 1.509 2.211 2.675 1.486l10.607-6.6a1.73 1.73 0 0 0 .718-.879V19.5a.75.75 0 0 0 1.5 0v-15a.75.75 0 0 0-1.5 0v6.893a1.729 1.729 0 0 0-.718-.879l-10.607-6.6ZM5.75 5.4a.25.25 0 0 1 .382-.212l10.607 6.6a.25.25 0 0 1 0 .424l-10.607 6.6a.25.25 0 0 1-.382-.212V5.4Z" })));
});
